/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AnimationGiftCouponCard,
  AnimationGiftCouponCardList,
  AnimationGiftCouponWrapper,
  CardListContent,
} from "./atom";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";
import { useEffect, useState } from "react";
import CheckIcon from "@/assets/icons/topup/check";
import CouponIcon from "@/assets/icons/topup/coupon-icon";
import LeftIcon from "@/assets/icons/topup/left-icon";
import RightIcon from "@/assets/icons/topup/right-icon";
import { useAnimationTopUpStore } from "../../store";
import {
  getLotteryNumber,
  presentAmountCalculate,
  rulesContentList,
} from "@/components/top-up/help/activityUtil";
import { useScrollCard } from "./hooks/useScrollCard";
import { BindActivityInfo } from "@/components/top-up/types";
import ActivityRule from "@/components/top-up/components/activity-rule";
import {
  CommonCornerMark,
  ActivityRuleAndCoupon,
  AnimationCouponCode,
} from "../../atom";
import LuckDrawActiveIcon from "@/assets/icons/topup/luck-draw-active-icon";
import LuckDrawIcon from "@/assets/icons/topup/luck-draw-icon";

export function AnimationGiftCoupon({
  activityInfo,
}: {
  activityInfo: BindActivityInfo;
}) {
  const { t } = useTranslation("topup");
  const { isZh, currencySymbol } = useGlobalStore();

  const [openActivityRuleDrawer, setOpenActivityRuleDrawer] = useState(false);
  const [checkCard, setCheckCard] = useState(activityInfo.activityDetail[0]);
  // const [checkCardIndex, setCheckCardIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const card = searchParams.get("chooseCard");
  const activeName = useAnimationTopUpStore((state) => state.activeName);
  const isCheckCard = useAnimationTopUpStore((state) => state.isCheckCard);
  const luckDrawGiftActivityInfo = useAnimationTopUpStore(
    (state) => state.luckDrawGiftActivityInfo
  );
  const lotteryActivityInfoList = useAnimationTopUpStore(
    (state) => state.lotteryActivityInfoList
  );
  const verifyRechargeInfo = useAnimationTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const { setter: setAnimationTopUpStore } = useAnimationTopUpStore();
  const {
    isLeftHidden,
    isRightHidden,
    scrollRight,
    scrollLeft,
    wrapperRef,
    scrollTo,
  } = useScrollCard();
  const [hoverCard, setHoverCard] = useState(0);

  const openCouponModal = () => {
    setAnimationTopUpStore((state) => {
      state.showCouponCodeModal = true;
      if (verifyRechargeInfo.couponNO) {
        state.inputCode = verifyRechargeInfo.couponNO;
      }
    });
  };

  useEffect(() => {
    if (card) {
      setCheckCard(
        activityInfo.activityDetail.find(
          (item) => item.amount === Number(card)
        ) || {}
      );
      setAnimationTopUpStore({
        amount: Number(card),
        isCheckCard: true,
      });
      const cardIndex =
        activityInfo.activityDetail.findIndex(
          (item) => item.amount === Number(card)
        ) || 0;
      const scrollTimes = Math.floor((cardIndex + 1) / 4); // 计算滚动次数
      if (scrollTimes >= 1) scrollTo(scrollTimes);
    } else {
      setCheckCard(activityInfo.activityDetail[0]);
      setAnimationTopUpStore({
        amount: activityInfo.activityDetail[0].amount,
        isCheckCard: true,
      });
    }
  }, [activeName]);

  return (
    <AnimationGiftCouponWrapper>
      <ActivityRuleAndCoupon>
        <ActivityRule
          ruleList={rulesContentList(
            luckDrawGiftActivityInfo || activityInfo,
            isZh
          )}
          openRuleDrawer={openActivityRuleDrawer}
          changeDrawer={(val) => {
            setOpenActivityRuleDrawer(val);
          }}
          activityInfo={luckDrawGiftActivityInfo || activityInfo}
        />
        <AnimationCouponCode onClick={openCouponModal}>
          {t("renderbus_recharge_redemption_code")}
        </AnimationCouponCode>
      </ActivityRuleAndCoupon>
      <CardListContent>
        {activityInfo.activityDetail.length > 4 && !isLeftHidden && (
          <LeftIcon
            onClick={scrollLeft}
            className="scroll-button left-button"
          />
        )}
        <div className="card-list-wrapper" ref={wrapperRef}>
          <AnimationGiftCouponCardList className="cards-wrapper">
            {activityInfo.activityDetail.map((item, index) => {
              const price = item.amount || 0;
              const isCheckedCard =
                checkCard.amount === price &&
                checkCard.id === item.id &&
                isCheckCard;
              const lotteryNumber = luckDrawGiftActivityInfo
                ? getLotteryNumber(
                    luckDrawGiftActivityInfo,
                    lotteryActivityInfoList,
                    price
                  )
                : 0;
              return (
                <AnimationGiftCouponCard
                  isActive={isCheckedCard}
                  onClick={() => {
                    setCheckCard(item);
                    setAnimationTopUpStore((state) => {
                      state.amount = price;
                      state.isCheckCard = true;
                    });
                    // setCheckCardIndex(index)
                  }}
                  onMouseEnter={() => setHoverCard(index + 1)}
                  onMouseLeave={() => setHoverCard(0)}
                  heightCard={Boolean(luckDrawGiftActivityInfo)}
                  key={item.id}
                >
                  {item.iconWord && item.iconWord !== "" && (
                    <CommonCornerMark>{item.iconWord}</CommonCornerMark>
                  )}
                  <div className="recharge-price">
                    <div>
                      <span className="unit">{currencySymbol}</span>
                      <span className="price">{price}</span>
                    </div>
                    {isCheckedCard && <CheckIcon />}
                  </div>
                  <div className="extra-welfare">
                    {(!item.detailList ||
                      !item.detailList.length ||
                      item.detailList.length <= 1) && (
                      <>
                        <div className="tip-text">
                          {t("topUp_first_extra_welfare")}
                        </div>
                        <div className="gift-amount">
                          <CouponIcon />
                          <span>
                            {currencySymbol}
                            {presentAmountCalculate(
                              activityInfo,
                              price,
                              item.presentAmount
                            ) ?? 0}
                            &nbsp;
                            {couponTypeTranslate(item.couponType ?? 0)}
                          </span>
                        </div>
                      </>
                    )}
                    {luckDrawGiftActivityInfo && lotteryNumber > 0 && (
                      <div className="luck-draw-text">
                        {isCheckedCard || hoverCard === index + 1 ? (
                          <LuckDrawActiveIcon />
                        ) : (
                          <LuckDrawIcon />
                        )}
                        <span>
                          {t("topup_lottery_coupon")}&nbsp;{lotteryNumber}
                          {t("topup_lottery_coupon_unit")}
                        </span>
                      </div>
                    )}
                  </div>
                </AnimationGiftCouponCard>
              );
            })}
          </AnimationGiftCouponCardList>
        </div>
        {activityInfo.activityDetail.length > 4 && !isRightHidden && (
          <RightIcon
            onClick={scrollRight}
            className="scroll-button right-button"
          />
        )}
      </CardListContent>
    </AnimationGiftCouponWrapper>
  );
}
